import React, { useEffect } from 'react';
import './Loading.css';
import { plog } from '../../utils/perfLog';

const Loading = ({ isExiting = false }) => {
  useEffect(() => {
    plog('gate', '🟠 LOADING overlay SHOWN (luxury clinic animation)');
    return () => plog('gate', '⚪️ LOADING overlay HIDDEN');
  }, []);

  return (
    <div
      className={`loading-wrapper ${isExiting ? 'loading-exit' : ''}`}
      role="status"
      aria-label="Loading"
    >
      <div className="loading-container">
        {/* DUAL ORBITAL RINGS WITH MANDARIN EMBLEM */}
        <div className="loading-orb">
          <div className="loading-ring outer-ring" />
          <div className="loading-ring inner-ring" />
          <div className="loading-emblem-holder">
            <svg
              viewBox="0 0 122 90"
              className="loading-emblem-svg"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M61.96,73.6c-3.1-18.36,1.85-39.98,18.03-51.18,7.03-5.03,15.59-6.75,23.89-7.64.04,14.38-.17,28.8-1,43.16-.5,13.59-10.03,26.61-23.01,30.13,10.15-6.72,16.38-18.27,15.58-30.13-.71-12.58-.99-25.18-.99-37.77l5.32,4.66c-24.67,2.58-34.64,26.93-37.83,48.77h0Z" />
              <path d="M61.96,44.78c-6.5-14.3-20.53-21.63-35.88-20.7,0,0,4.5-4.51,4.5-4.51.14,6.34.25,12.67.17,19.01-.05,7.83-.36,15.83-.79,23.67-.47,10.53,4.8,20.05,13.72,26.23-14-3.15-22.14-16.87-21.73-30.89-.65-12.67-.71-25.34-.38-38.02l.11-4.63,4.39.12c17.47,0,34.67,11.26,35.9,29.72h0Z" />
              <path d="M62.62.17c-1.45,6.07-6.19,10.81-12.26,12.26,6.07,1.45,10.81,6.19,12.26,12.26,1.45-6.07,6.19-10.81,12.26-12.26-6.07-1.45-10.81-6.19-12.26-12.26Z" />
              <path d="M120.78,28.25c.03,11.75-.13,23.53-.8,35.25-.42,11.08-8.19,21.71-18.78,24.58,8.28-5.49,13.38-14.9,12.72-24.58-.5-8.74-.74-17.49-.8-26.23-5.15,1.22-9.79,3.51-13.95,6.56v-8.55c.53-.35,1.07-.67,1.62-1,5.96-3.73,13.1-5.19,19.99-6.02Z" />
              <path d="M23.31,41.94c-4.58-3.4-9.95-5.6-15.74-5.71.08,3.95.13,7.92.06,11.89-.03,6.34-.3,12.8-.64,19.14-.31,8.53,3.98,16.21,11.2,21.23C6.84,85.88.22,74.93.49,63.51-.06,53.27-.11,43.01.16,32.73l.08-3.58c4.63-.2,9.46-.17,13.9,1.36,3.39,1.11,6.49,2.92,9.18,5.24v6.18Z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
